import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'antd'
import {
  Form,
  TextInput,
  TextAreaInput,
  SubmitButton,
  // UploadImage,
} from '@components/Form'
import { useLocalization } from '@contexts/LocalizationContext'
import validationSchema from './validationSchema'

const FormComponent = ({ defaultValues = {}, handleSubmit }) => {
  const { t } = useLocalization()

  const formItemLayout = {
    labelAlign: 'left',
  }

  return (
    <Form
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema(t)}
    >
      <Row>
        <Col flex="auto">
          <TextInput
            name="name"
            label={t('specialty.form.label.name')}
            formItemOptions={{ formItemLayout }}
          />
          <TextAreaInput
            name="detail"
            label={t('specialty.form.label.detail')}
            formItemOptions={{ formItemLayout }}
          />
          <SubmitButton formItemOptions={{ formItemLayout }}>
            {t('hospital.form.saveButton')}
          </SubmitButton>
        </Col>
      </Row>
    </Form>
  )
}

FormComponent.propTypes = {
  defaultValues: PropTypes.object,
  handleSubmit: PropTypes.func,
}

export default FormComponent
